<app-dialog
  headerGlyph="trash"
  [headerText]="title"
  saveText="Delete"
  [showTopCancelButton]="false"
  [body]="body"
  (save)="onDelete()"
  [validationFn]="validate.bind(this)"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div>
          Folder '{{ this.resource.displayName }}' in path
          {{ this.resource.path }} contains data. <br /><br />
          Are you sure want to permanently delete it and all its contents?
          <br /><br />
          We recommend that you first review its content, and then come back and
          safely delete the folder.
          <br /><br />
          <strong>NOTE:</strong>
          <ul>
            <li>This action cannot be undone.</li>
            <li>
              Deleting a folder that contains a managed service will also delete
              instances of the type defined in its RTD, provided that all
              instances are within this folder. If any instances are located
              outside the folder, the deletion will not succeed.
            </li>
          </ul>
          <strong>TIP:</strong> You can use the
          <strong>RTD Type Resources</strong> tab in the details view of a
          managed service to locate all its instances and then manually delete
          them. <br /><br />
        </div>
        <app-constraint-notification
          [resource]="resource"
          type="delete"
        ></app-constraint-notification>
        @if (!!errorMsg) {
          <app-error-strip
            [errorText]="FAILED_MSGS[resource.type] || 'Cannot delete resource'"
            [errorMsg]="errorMsg"
          ></app-error-strip>
        }
        <div class="checkbox-container">
          <fd-checkbox
            id="confirmDelete"
            [(ngModel)]="isSaveEnabled"
            [fdCompact]="true"
          >
          </fd-checkbox>
          <label for="confirmDelete">
            I understand and confirm that I want to permanently delete this
            folder and its contents.
          </label>
        </div>
      </div>
    }
  </ng-template>
</app-dialog>
